module.exports = __webpack_public_path__ + "assets/images/1e48b8de0312b09b3167111480a5a75c.png";